<div class="conversionContainer container-fluid" id="home" *ngIf="!!content && pageNotFound === false">
    <app-credit-card-conversion-header [logoImage]="content?.logoImage" [headerLinks]="content?.headerLinks"
        [footerLinks]="content?.footerLinks" [logoLink]="content?.logoLink"></app-credit-card-conversion-header>
    <app-credit-card-conversion-banner [contentBanner]="content?.banner"></app-credit-card-conversion-banner>
    <div class="parallaxContainer" id="parallax-cont-001"></div>
    <app-credit-card-conversion-reward-calculator [contentRewards]="content?.rewards">
    </app-credit-card-conversion-reward-calculator>
    <div class="parallaxContainer" id="parallax-cont-002"></div>
    <app-credit-card-conversion-benefits [contentBenefits]="content?.benefits">
    </app-credit-card-conversion-benefits>
    <div class="parallaxContainer" id="parallax-cont-003"></div>
    <app-credit-card-conversion-learn-more id="footer" [contentLearnMore]="content?.learnMore">
    </app-credit-card-conversion-learn-more>
    <app-credit-card-conversion-footer *ngIf="content?.footerContent" [footerContent]="content?.footerContent"></app-credit-card-conversion-footer>
</div>